import ClassNames from "classnames";
import { FunctionComponent } from "react";
import { IconName } from "../types/index.js";
import Icon from "./Icon.js";

interface Props {
  icon: IconName;
  title: string;
  onClick: () => void;
  isActive?: boolean;
}

const ItemsListButton: FunctionComponent<Props> = ({
  title,
  icon,
  onClick,
  isActive = false,
}) => (
  <button
    type="button"
    onClick={onClick}
    className={ClassNames("Btn Btn--compact ControlItem__Btn", {
      "Btn--active": isActive,
    })}
    title={title}
  >
    <Icon glyph={icon} />
  </button>
);

export default ItemsListButton;
